const roles = {

}

export default {
  'get|/roles/query': option => {
    return {
      status: 200,
      data: roles,
      message: '操作成功!'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mock/modules/roles.js